import script from "./air-quality-monitor.vue?vue&type=script&lang=js"
export * from "./air-quality-monitor.vue?vue&type=script&lang=js"

import "./air-quality-monitor.vue?vue&type=style&index=0&id=2829ed69&lang=scss"

const __exports__ = script;

export default __exports__